import {asyncNames} from '../../lib/asyncUtil'
import {TFA_CONFIG, SIGN_OUT, TFA_CONFIGS} from '../actionTypes'
import {stateValue} from '../../lib/data'

const initialState = {loading: false, tfa: {}, tfaConfigs: [], failed: false, error: null}

const tfaReducer = (state = initialState, action) => {
  switch (action.type) {
    case asyncNames(TFA_CONFIG).loading:
    case asyncNames(TFA_CONFIGS).loading:
      return {...state, loading: action.data}
    case asyncNames(TFA_CONFIG).success:
      return {...state, tfa: action.data, loading: false, failed: false, error: null}
    case asyncNames(TFA_CONFIGS).success:
      return {...state, tfaConfigs: stateValue({data: action.data, records: state.tfaConfigs}), loading: false, failed: false, error: null}
    case asyncNames(TFA_CONFIG).failure:
    case asyncNames(TFA_CONFIGS).failure:
      return {...state, loading: false, error: action.data.error, failed: action.data.status}
    case  asyncNames(SIGN_OUT).success:
      return {...state, tfa: {}, tfaConfigs: []}
    default:
      return state
  }
}

export default tfaReducer
